export default "__VITE_ASSET__8fa7dbc4__"